import {
  ThreeDPrintOnly,
  CubeCheck,
  Man,
  Game,
  CubeOutline2,
  LowPoly2,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { USE_CASE, POLY_COUNT, POLYGON_TYPE, MATERIAL } from 'Pods/ThreeDStudio/Store/constants'

export const useCaseOptions = [
  {
    id: USE_CASE.STANDARD,
    title: 'Standard',
    description: 'Good for most cases. Balanced quality and polygon count with PBR textures.',
    icon: CubeCheck,
    preset: {
      targetPolycount: 45000,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.PBR,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.HERO,
    title: 'Hero asset',
    description: 'Maximum quality. Dense quad mesh with full PBR - ideal for high quality assets.',
    icon: Man,
    preset: {
      polyCount: POLY_COUNT.HIGH,
      polygonType: POLYGON_TYPE.QUADRILATERAL,
      material: MATERIAL.PBR,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.PROP,
    title: 'Prop asset',
    description: 'Game-ready prop with medium polygon count.',
    icon: Game,
    preset: {
      polyCount: POLY_COUNT.MEDIUM,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.PBR,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.THREE_D_PRINT,
    title: '3D print',
    description: 'High density triangulated mesh for 3D printing with basic material.',
    icon: ThreeDPrintOnly,
    preset: {
      polyCount: POLY_COUNT.HIGH,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.BASIC,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.SHAPE_ONLY,
    title: 'Shape only',
    description: 'High density mesh with no textures. Ideal for validating geometry and surface detail.',
    icon: CubeOutline2,
    preset: {
      polyCount: POLY_COUNT.HIGH,
      polygonType: POLYGON_TYPE.TRIANGLE,
      material: MATERIAL.GEOMETRY_ONLY,
      isSmartLowPoly: false,
    },
  },
  {
    id: USE_CASE.LOW_POLY,
    title: 'Low Poly',
    description: 'Low polygon count mesh with PBR textures.',
    icon: LowPoly2,
    preset: {
      isSmartLowPoly: true,
    },
  },
]
